// ==========================================
// Sub-Client: Client Setup

import { MenuItem } from "./types";

// ==========================================
export const sub_client_client_setup: MenuItem[] = [
  {
    permission: "MANAGE_USER",
    to: "/subclient/manage-user/users?sortBy=userName&orderBy=ASC&page=1&pageSize=10",
    title: "User",
  },
  {
    permission: "MANAGE_ROLE",
    to: "/subclient/manage-user/roles?sortBy=roleName&orderBy=ASC&page=1&pageSize=10",
    title: "Role",
  },
];

// ==========================================
// Sub-Client: Logs & History
// ==========================================
export const sub_client_logs_and_history: MenuItem[] = [
  {
    permission: "EMAIL_LOG",
    to: "/subclient/log-history/email?sortBy=emailSentOn&orderBy=DESC&page=1&pageSize=10",
    title: "Email Log History",
  },
  {
    permission: "USER_ACTION_HISTORY",
    to: "/subclient/log-history/user?sortBy=actionTime&orderBy=DESC&page=1&pageSize=10",
    title: "User Action History",
  },
  {
    permission: "SCHEDULER_LOGS",
    to: "/subclient/log-history/schedularLog?sortBy=startedProcessingOn&orderBy=DESC&page=1&pageSize=10",
    title: "Scheduler Log History",
  },
];

// ==========================================
// Sub-Client: Manage User (same as client_setup)
// ==========================================
export const sub_client_manage_user = sub_client_client_setup;

// ==========================================
// Sub-Client: Customer File
// ==========================================

export const sub_client_account_management: MenuItem[] = [
  {
    permission: "CUSTOMER_FILE_MAINTENANCE",
    to: "/subclient/account-management/accounts",
    title: "Accounts",
  },
  {
    permission: "MANAGE_AR_TRANSACTIONS",
    to: "/subclient/account-management/transactions",
    title: "Transactions",
  },
  {
    permission: "MANAGE_SPECIAL_SERVICE_TICKET",
    to: "/subclient/account-management/special-service-tickets",
    title: "Special Service Tickets",
  },
]


// ==========================================
// Sub-Client: Billing
// ==========================================
export const sub_client_billing: MenuItem[] = [
  {
    permission: "BILLING_BATCH",
    to: "/subclient/billing/billing-batch",
    title: "Billing Batch",
  },
  {
    permission: "MANAGE_STATEMENT_MESSAGE",
    to: "/subclient/billing/statement-message",
    title: "Statement Message",
  },
  {
    permission: "MANAGE_BILLING_GROUPS",
    to: "/subclient/billing/billing-groups",
    title: "Billing Groups",
  },
];

// ==========================================
// Sub-Client: Rate Management
// ==========================================
export const sub_client_rate_management: MenuItem[] = [
  {
    permission: "REGULAR_RATE_MAINTENANCE",
    to: "/subclient/rate-management/regular-rates",
    title: "Regular Rates",
  },
  {
    permission: "CUSTOM_RATE_SEARCH",
    to: "/subclient/rate-management/custom-rates",
    title: "Custom Rates",
  },
  {
    permission: "MANAGE_SPECIAL_SERVICE_RATE",
    to: "/subclient/rate-management/special-service-rates",
    title: "Special Service Rates",
  },
  {
    permission: "MANAGE_MINIMUM_WEIGHT_AND_RATE",
    to: "/subclient/rate-management/weight-rates",
    title: "Weight Rates",
  },
  {
    permission: "MANAGE_MINIMUM_WEIGHT_AND_RATE",
    to: "/subclient/rate-management/container-minimum-weights",
    title: "Container Minimum Weights",
  },
  {
    permission: "MANAGE_JURISDICTION_DETAILS",
    to: "/subclient/rate-management/jurisdiction-details",
    title: "Jurisdiction Details",
  },
  {
    permission: "MANAGE_RATE_MAINTENANCE",
    to: "/subclient/rate-management/bulk-upload",
    title: "Rates Import/Export",
  },
];


export const sub_client_reports: MenuItem[] = [
  {
    permission: ["MANAGE_ROUTE_SHEET"],
    to: "/subclient/reports/route-sheets",
    title: "Route Sheets",
  },
  {
    permission: ["REPORTS"],
    to: "/subclient/reports/system-reports",
    title: "System Reports",
  },
];

export const sub_client_system_settings: MenuItem[] = [
  {
    permission: "MANAGE_ACCOUNT_GROUPS",
    to: "/subclient/system-settings/account-groups?sortBy=accountGroupName&orderBy=ASC&page=1&pageSize=10",
    title: "Account Groups",
  },
  {
    permission: "MANAGE_LETTERS",
    to: "/subclient/system-settings/manage-letters",
    title: "Manage Letter(s)",
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/tax-fee-types',
    title: 'Tax/Fee Types'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/material-types',
    title: 'Material Types'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/commodity-types',
    title: 'Commodity Types'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/vehicle-types',
    title: 'Vehicle Types'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/container-types',
    title: 'Container Types'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/container-type-options',
    title: 'Container Type Options'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/container-size-models',
    title: 'Container Size/Models'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/service-types',
    title: 'Service Types'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/distribution-types',
    title: 'Distribution Types'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/rate-detail-descriptions',
    title: 'Rate Detail Descriptions'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/jurisdictions',
    title: 'Jurisdictions'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/rate-types',
    title: 'Rate Types'
  },
  {
    permission: 'MANAGE_DISPATCH_ADDRESS_MASTERS',
    to: '/subclient/system-settings/dispatch-address',
    title: 'Site Addresses'
  }
];


export const sub_client_import_export: MenuItem[] = [
  {
    permission: "MANAGE_IMPORT_EXPORT",
    to: "/subclient/import-export",
    title: "Import/Export",
  },
]


